import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../../../views/types';
import type { SectionsPropsType } from '../../../../sections/types';
import { renderAdvisorMessage } from '../../../../views/AdvisorMessage';
import { renderUserMessage } from '../../../../views/UserMessage';
import { renderSimpleButtonGroup } from '../../../../views/SimpleButtonGroup';
import { renderSingleImage } from '../../../../views/SingleImage';
import { buildAnswers, buildUserAnswerMessage } from '../../../../sections/utils';

import WallCrackExampleJpgPath from 'Images/me/pages/guest/proposals/new/wall_crack/example.jpg'
import WallCrackExampleWebPPath from 'Images/me/pages/guest/proposals/new/wall_crack/example.webp'

const SECTION_KEY_NAME = 'wallCrack';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'crack';

export const wallCrackSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: 'より大きなヒビがあります', textContents: (<>より大きな<br />ヒビがある</>) },
    { value: 'あります', textContents: 'ある' },
    { value: 'まったくない', textContents: (<>まったく<br />ない</>) },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '外壁にひび割れはあるか',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    imagePaths: {
      imagePath: WallCrackExampleJpgPath,
      webp: WallCrackExampleWebPPath,
    },
    altText: '外壁のひび割れ',
    viewWidth: {
      pc: 350,
      mobile: 320,
    },
    imageRatio: { width: 350, height: 222 },
    withWebp: true,
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        窓サッシのまわりなどによく見られる、髪の毛の細さのヒビを、ヘアークラックといいます。
      </>
    ),
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        ヘアークラックはありますか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.value),
  });

  // 回答内容を返却する
  return answer;
};
